export default "__VITE_ASSET__DothT_XR__$_?imageSize__"